import { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import bcrypt from 'bcryptjs';

interface DeviceRequest {
	deviceType: 'WEB' | 'MOBILE' | 'TABLET';
	deviceCode: string;
	deviceHash: string;
}

interface UseDeviceInfoReturn {
	deviceRequest: DeviceRequest;
}

const useDeviceInfo = (): UseDeviceInfoReturn => {
	const [deviceRequest, setDeviceRequest] = useState<DeviceRequest>({
		deviceType: 'WEB',
		deviceCode: '',
		deviceHash: ''
	});

	useEffect(() => {
		const START_SALT = process.env.START_SALT || '';
		const END_SALT = process.env.END_SALT || '';

		const generateDeviceCode = (uuid: string): string => {
			const saltedString = `${START_SALT}${uuid}${END_SALT}`;
			return bcrypt.hashSync(saltedString);
		};

		const jsonTryStringify = (obj: any): string => {
			try {
				return JSON.stringify(obj);
			} catch (error) {
				console.log('use-device-info - JSON stringify error:', error);
				return '{}';
			}
		};

		const detectDeviceType = (): 'WEB' | 'MOBILE' | 'TABLET' => {
			const userAgent = navigator.userAgent.toLowerCase();
			const isMobile = /mobile|android|iphone|ipod/.test(userAgent);
			const isTablet = /tablet|ipad/.test(userAgent) || (isMobile && window.innerWidth >= 768);

			if (isTablet) return 'TABLET';
			if (isMobile) return 'MOBILE';
			return 'WEB';
		};

		const initializeDeviceInfo = () => {
			let uuid = localStorage.getItem('deviceUUID');

			if (!uuid) {
				uuid = uuidv4();
				localStorage.setItem('deviceUUID', uuid);
			}

			const deviceInfo = {
				uuid: uuid
			};

			const deviceCode = generateDeviceCode(deviceInfo.uuid);
			const deviceHash = window.btoa(jsonTryStringify(deviceInfo));
			const deviceType = detectDeviceType();

			setDeviceRequest({
				deviceType,
				deviceCode,
				deviceHash
			});
		};

		initializeDeviceInfo();
	}, []);

	return { deviceRequest };
};

export default useDeviceInfo;
